module.exports = __webpack_public_path__ + "img/grid-01.91395561.svg";